import styled from "styled-components";

export const StyledSubtotal = styled.div`
  font-weight: 400;
  font-size: 13px;
  text-align: right;

  ${({ theme }) =>
    theme.typography.heading.xs.lineHeight &&
    `
    line-height: ${theme.typography.heading.xs.lineHeight};
  `}
`;
